import { Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { PageNotFound } from 'theSource/components/PageNotFound';
import { selectIsAuthenticated } from 'theSource/features';

interface RoutesInternalProps {
  children: JSX.Element | JSX.Element[];
}

export const RoutesInternal = ({ children }: RoutesInternalProps) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <Routes>
      {children}
      <Route
        path="*"
        element={<PageNotFound isFullScreen={!isAuthenticated} />}
      />
    </Routes>
  );
};
